export function isCDNBuild(): boolean {
  // Returns true if the SDK is being used in a browser environment by
  // importing the CDN <script> directly.
  return typeof window !== 'undefined' && __BUILD_FORMAT__ === 'iife';
}
